import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { intl } from "LocaleWrapper";

import DeclarationDialog from "../dialogs/DeclarationDialog";

import { CharterType } from "__generated__/enums";

type DeclareButtonProps = {
	charter: {
		id: number;
		type: CharterType;
	};
	invoiceGroupType?: { id?: number | null; name?: string | null } | null;
	declaration?: { id?: number; closedOn?: number | null } | null;
	refetch: () => void;
};

const DeclareButton = ({ charter, invoiceGroupType, refetch, declaration }: DeclareButtonProps) => {
	const [ dialogOpen, setDialogOpen ] = useState(false);

	return <>
		<Tooltip title={intl.formatMessage({ id: "DECLARE" })}>
			<IconButton
				size="small"
				onClick={() => setDialogOpen(true)}
				disabled={!!declaration?.closedOn}
			>
				<CalculateIcon fontSize="small" />
			</IconButton>
		</Tooltip>

		{dialogOpen && (
			<DeclarationDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				charterId={charter.id}
				declarationId={declaration?.id}
				invoiceGroupType={invoiceGroupType}
				onSaved={refetch}
			/>
		)}
	</>;
};

export default DeclareButton;
